import React from 'react'
import './Legend.css'

class Legend extends React.Component {
  state = {
    toggled: this.props.toggled,
  }

  handleToggle = e => {
    this.setState(prevState => ({
      toggled: !prevState.toggled
    }), () => this.props.onChange(this.state.toggled))
  }

  render() {
    return (
      <div className="Legend-map-overlay">
        <div className="Legend-map-overlay-legend">
          <div>
            <div>{this.props.legend[0]}</div>
          </div>
          <div>
            <div>{this.props.legend[1]}</div>
          </div>
        </div>
        <div className="Legend-map-overlay-toggle">
          <div className="Legend-map-overlay-toggle-label">{this.props.toggle[0]}</div>

          <label className="Legend-map-overlay-toggle-switch">
            <input type="checkbox" checked={this.state.toggled} onChange={() => {}} />
            <span onClick={this.handleToggle}>
              <span>{this.props.toggle[1]}</span>
              <span>{this.props.toggle[2]}</span>
            </span>
          </label>
        </div>
      </div>
    )
  }
}

export default Legend



// WEBPACK FOOTER //
// ./src/content/components/legend/Legend.js